import { render, staticRenderFns } from "./EmptyTable.vue?vue&type=template&id=ae84b58e&scoped=true&"
import script from "./EmptyTable.vue?vue&type=script&lang=ts&"
export * from "./EmptyTable.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyTable.vue?vue&type=style&index=0&id=ae84b58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae84b58e",
  null
  
)

export default component.exports